import React from 'react';
import { Button, Card, Col, Row, Typography, Upload } from "antd";
import styled from "@emotion/styled";
import { UploadOutlined } from "@ant-design/icons";

import useViewershipUploadDataHook from './hooks/useViewershipUploadDataHook';
import { TaskRow } from "../../zype/styled-components";
import { ComponentTitle, StledSpin } from "../../custom-components";

import UploaderFilterModal from './modals/UploaderFilterModal'; // Adjust the import path accordingly

import './file_upload.css';

const { Dragger } = Upload;

export const StyledDragger = styled(Dragger)`
	padding: 10px;
	& .ant-upload-drag {
		padding: 10px;
	}
`;

const FileUploadComponent = () => {
  const {
    loading,
    uploadProps,
    isFiltersSet,
    setIsFiltersSet,
    isModalOpen,
    setIsModalOpen,
    filterData,
    handleUploadWrapper,
    showTerritory,
    showMonth,
    showYear,
    handleSetFilters,
    closeFilterModal,
    platformOptions,
    territoryOptions,
    form,
    openFilterModal,
    handleFormChange,
    domain,
    platformKey,
    channelOptions,
    showChannel,
    showHOVField,
    showViewershipPartner,
    borrowerPartnerOptions
  } = useViewershipUploadDataHook();

  return (
    <div>
      {isModalOpen  &&(
        <UploaderFilterModal
          platformKey={platformKey}
          domain={domain}
          uploaderFilterModalOpen={isModalOpen}
          handleCancel={closeFilterModal}
          handleSetFilters={handleSetFilters}
          showTerritory={showTerritory}
          showMonth={showMonth}
          showYear={showYear}
          platformOptions={platformOptions}
          territoryOptions={territoryOptions}
          form={form}
          handleFormChange={handleFormChange} 
          channelOptions={channelOptions}
          showChannel={showChannel}
          showHOVField={showHOVField}
          showViewershipPartner={showViewershipPartner}
          borrowerPartnerOptions={borrowerPartnerOptions}
          loading={loading}
        />
      )}

      {!isFiltersSet &&(
        <button onClick={openFilterModal} className="button-style">
          Set Filters
        </button>
      )}

      {isFiltersSet &&(
        <div>
          <div className="filters-container">
            <h2 className="filter-title">Selected Filters</h2>
            <div className="filter-item">
              <p><strong>Domain:</strong> {filterData?.domain}</p>
            </div>
            <div className="filter-item">
              <p><strong>Platform:</strong> {filterData?.platform}</p>
            </div>
            {showTerritory && (
                <div className="filter-item">
                  <p><strong>Territory:</strong> {filterData?.territory}</p>
                </div>
            )}
            {showMonth && (
                <div className="filter-item">
                  <p><strong>Month:</strong> {filterData?.month}</p>
                </div>
            )}
            {showYear && (
              <div className="filter-item">
                <p><strong>Year:</strong> {filterData?.year}</p>
              </div>
            )}
            {/* {showChannel && (
              <div className="filter-item">
                <p><strong>Channel:</strong> {filterData?.channel}</p>
              </div>
            )}
            {showViewershipPartner && (
              <div className="filter-item">
                <p><strong>Viewership Partner:</strong> {filterData?.viewershipPartner}</p>
              </div>
            )} */}
        </div>

          <div className="reset-button-container">
            <button
              onClick={() => { setIsFiltersSet(false); setIsModalOpen(true); }}
              className="button-style"
            >
              Reset Filters
            </button>
          </div>

          <StledSpin spinning={loading}>
            <TaskRow>
              <Card
                actions={[
                  <Button key="import-btn" type="primary" onClick={handleUploadWrapper} loading={loading} disabled={loading}>
                    Upload Data
                  </Button>,
                ]}
              >
                <StyledDragger {...uploadProps} disabled={loading}>
                  <Typography.Paragraph>
                    Please select a CSV file to import data into the database
                  </Typography.Paragraph>
                  <Button icon={<UploadOutlined />} disabled={loading}>Select File</Button>
                </StyledDragger>
              </Card>
            </TaskRow>
          </StledSpin>
        </div>
      )}
    </div>
  );
};

export default FileUploadComponent;
